import { useFormDataQuery } from '@/api/getters';
import DownloadBadge from '@/components/DownloadBadge';
import AfterDoc from '@/components/ui/AfterDoc';
import { CONSULTANTS } from '@/features/v2/consultants';

import { useLingui } from '@lingui/react';

const DownloadFiles = () => {
  const { i18n } = useLingui();

  const { data } = useFormDataQuery();

  if (!data) return null;

  return (
    <AfterDoc
      consultant={CONSULTANTS.EWELINA_ASSISTANT}
      title={data.user.first_name + i18n.t(', dotarliśmy do celu!')}
      thankYouMessage={i18n.t(
        'Dziękujemy za Twoje zaangażowanie. Dokumenty są gotowe do pobrania, a sprawa została przekazana do działu płatności, czas oczekiwania wynosi 14 dni.'
      )}
      icon={'finish'}
    >
      {/* TODO: add surcharge after Patryk's response */}
      {/* {data?.offer?.surcharge_summary && data?.offer?.surcharge && (
        <Summary
          subheading={i18n.t('Dopłata do odszkodowania')}
          withButtons={false}
          surcharge={data?.offer?.surcharge}
          total={data?.offer?.surcharge_summary}
          tax={data?.offer?.tax ?? 0}
          className="bg-white lg:max-w-full"
        />
      )} */}
      <p className="body">
        {i18n.t(
          'W przypadku ręcznego podpisu na pełnomocnictwie oraz oświadczeniach, przypominamy o odesłaniu oryginałów na adres: Helpfind sp. z o.o., ul. Kazimierza Pułaskiego 11, 63-400 Ostrów Wielkopolski'
        )}
        <p className="body mt-4">
          {i18n.t(
            'Jeśli masz dodatkowe pytania, jesteśmy do Twojej dyspozycji.'
          )}
        </p>
      </p>
      <div className="flex flex-col gap-2.5">
        {data?.attachments?.map((item, index) => (
          <DownloadBadge
            key={`${index}-${item}`}
            name={item.name}
            onClick={() => window.open(item.url, '_blank')}
            size={item.size}
          />
        ))}
      </div>
    </AfterDoc>
  );
};

export default DownloadFiles;
